module.exports = {
  normal: "normal",
  onFly: "onFly",
};
